import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCoffee,
  faCalendar,
  faProjectDiagram,
  faFileImport,
  faCalendarCheck,
} from "@fortawesome/free-solid-svg-icons";
import "../css/DashboardTurnos.css";
import ModalConfiguracionHorario from "../components/ModalConfiguracionHorario";
import ModalConfigurarTurno from "../components/ModalConfigurarTurno";
import ImportarRegistroModal from '../forms/Registros/ImportarRegistroModal';
import ModalExportarAsistencia from "../forms/Asistencia/ModalExportarAsistencia";
import LoadingOverlay from "../components/LoadingOverlay";
import { NewContext } from "../utils/ContextProvider";
import { getExportWithDetail, getExportWithOutDetail } from "../utils/peticionesApi";

const pasos = [
  {
    titulo: "Historial de Turnos",
    descripcion: "Acá podés visualizar los turnos, relacionado a la aplicación",
    icono: faCoffee,
  }
];

const acciones = [
  {
    titulo: "Importador de Asistencia",
    descripcion: "En esta sección vamos a poder importar registros de asistencia para tu personal, relacionado a la app",
    icono: faFileImport,
  },
  {
    titulo: "Reporte de Asistencia",
    descripcion: "Vista de marcaciones por empleados",
    icono: faCalendarCheck,
  },
];

const DashboardTurnos = () => {
  const { getAlert, getDepartment } = useContext(NewContext)
  const [showModalConfig, setShowModalConfig] = useState(false);
  const [showModalTurno, setShowModalTurno] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showModalExport, setShowModalExport] = useState(false);
  const [isLoadingModalTurno, setIsLoadingModalTurno] = useState(false);
  const [idDepartamento, setIdDepartamento] = useState(getDepartment);

  const [detalle, setDetalle] = useState(true);
  const [detail, setDetail] = useState(false);
  const [uuid, setUuid] = useState(null);
  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [dateExport, setDateExport] = useState({ exportDesde: null, exportHasta: null });

  const navigate = useNavigate();

  const handleAgregarPeriodo = (nuevoPeriodo) => {
    console.log("Nuevo turno agregado:", nuevoPeriodo);
  };

  const handlePasoClick = (titulo) => {
    if (titulo === "Historial de Turnos") {
      navigate("/registro/");
    }
  };
  const handleExportChange = e => {
    const [año, mes, dia] = e.target.value.split('-')
    setDateExport({ ...dateExport, [e.target.name]: `${dia}/${mes}/${año}` })
  }

  const submitExport = async (onClose) => {
    if (!dateExport.exportDesde || !dateExport.exportHasta) {
      return getAlert({ msj: `No se ingresó la fecha.`, tipe: 'error' });
    }

    const departmentIds = selectedDepartments.length > 0
      ? [...new Set(selectedDepartments)].filter(id => id).join(',')
      : '0';

    const zktecoAvailable = selectedDepartments.length > 0;

    try {
      const peticion = detail
        ? getExportWithDetail(-1, dateExport.exportDesde, dateExport.exportHasta, uuid, departmentIds, zktecoAvailable)
        : getExportWithOutDetail(-1, dateExport.exportDesde, dateExport.exportHasta, uuid, departmentIds, zktecoAvailable);

      const res = await peticion;
      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'asistencias.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);

      onClose();

    } catch (error) {
      console.log(error);
      getAlert({ msj: "Error al exportar los datos", tipe: "error" });
    }
  };

  return (
<div className="contenedor-dashboard-turnos">

      <p className="titulo-seccion">Pasos de configuración de horarios</p>
      <div className="bloques-pasos">

      <div
          className="card-paso"
          onClick={async () => {
            setIsLoadingModalTurno(true);
            try {
              await new Promise(resolve => setTimeout(resolve, 500));
            } finally {
              setIsLoadingModalTurno(false);
              setShowModalTurno(true);
            }
          }}
          style={{ cursor: "pointer" }}
        >
          <FontAwesomeIcon icon={faCalendar} className="icono-paso" />
          <h4>Configurar turno</h4>
          <p>Configurar turnos por empleado</p>
        </div>

        <div
          className="card-paso"
          onClick={() => setShowModalConfig(true)}
          style={{ cursor: "pointer" }}
        >
          <FontAwesomeIcon icon={faProjectDiagram} className="icono-paso" />
          <h4>Configurar horario</h4>
          <p>Asignar turnos por empleados</p>
        </div>

        {pasos.map((paso, index) => (
          <div
            className="card-paso"
            key={index}
            onClick={() => handlePasoClick(paso.titulo)}
            style={{ cursor: "pointer" }}
          >
            <FontAwesomeIcon icon={paso.icono} className="icono-paso" />
            <h4>{paso.titulo}</h4>
            <p>{paso.descripcion}</p>
          </div>
        ))}

      </div>

      <p className="titulo-seccion">Importador de Asistencia</p>
      <div
        className="card-paso"
        onClick={() => setShowImportModal(true)}
        style={{ cursor: "pointer" }}
      >
        <FontAwesomeIcon icon={acciones[0].icono} className="icono-paso" />
        <h4>{acciones[0].titulo}</h4>
        <p>{acciones[0].descripcion}</p>
      </div>

      <p className="titulo-seccion">Generar Reporte</p>
      <div className="bloques-pasos">
        <div
          className="card-paso"
          onClick={() => setShowModalExport(true)}
          style={{ cursor: "pointer" }}
        >
          <FontAwesomeIcon icon={acciones[1].icono} className="icono-paso" />
          <h4>{acciones[1].titulo}</h4>
          <p>{acciones[1].descripcion}</p>
        </div>
      </div>

      {showModalConfig && (
        <ModalConfiguracionHorario onClose={() => setShowModalConfig(false)} />
      )}

      {isLoadingModalTurno && <LoadingOverlay isLoading={isLoadingModalTurno} />}

      {showModalTurno && (
        <ModalConfigurarTurno
          onClose={() => setShowModalTurno(false)}
          onAgregar={handleAgregarPeriodo}
        />
      )}

      {showImportModal && (
        <ImportarRegistroModal
          showModal={showImportModal}
          closeModal={() => setShowImportModal(false)}
        />
      )}

      {showModalExport && (
        <ModalExportarAsistencia
          onClose={() => setShowModalExport(false)}
          detalle={detalle}
          setDetalle={setDetalle}
          uuid={uuid}
          setUuid={setUuid}
          selectedDepartments={selectedDepartments}
          setSelectedDepartments={setSelectedDepartments}
          dateExport={dateExport}
          handleExportChange={handleExportChange}
          detail={detail}
          setDetail={setDetail}
          submitExport={() => submitExport(() => setShowModalExport(false))}
        />
      )}
    </div>
  );
};

export default DashboardTurnos;